import { Button, CircularProgress } from '@material-ui/core';
import moment from 'moment-timezone';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { COLORS } from 'shared/constants/COLORS';
import { ROUTES } from 'shared/constants/ROUTES';
import { CustomTypography } from 'shared/elements/CustomTypography';
import { IVerifyAuditionResponse } from 'shared/interfaces/IAudition';
import { authService } from 'shared/services/authService';
import { EVerificationStep } from '../Unauthenticated';
import { setUser } from 'shared/redux/slicers/user.slicer';
import { ls } from 'shared/utils/ls';
import { format } from 'date-fns';

interface Props {
  data?: IVerifyAuditionResponse['data'];
  talentName: string;
  onCancel: () => void;
}

const { generateToken } = authService();

const Result: React.FC<Props> = ({ data, talentName, onCancel }) => {
  const { mutate, isLoading } = generateToken();
  const indexZeroForNow = data?.[0];
  const history = useHistory();
  const { setLS } = ls();

  const proceed = () => {
    const user_id = indexZeroForNow?.user_id;
    if (user_id) {
      mutate(user_id, {
        onSuccess: (res) => {
          const { data: user, token } = res;
          setLS('auth_token', token);
          setLS('user', JSON.stringify(user));
          setLS('access_public', 'true');
          // setLS('is_completed_primary_details', user.attributes.completed_primary_details);
          history.push(`${ROUTES.UNAUTHENTICATED}/${EVerificationStep.SIZES}`);
        },
      });
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 20,
      }}
    >
      <CustomTypography variant="h1">Hi {talentName},</CustomTypography>
      <CustomTypography>Here are the audition details we have for you:</CustomTypography>
      <div style={{ background: '#151a21', padding: '20px 50px', borderRadius: 8 }}>
        {/* table for info */}
        <table>
          <tbody>
            <tr>
              <td>
                <CustomTypography style={{ color: COLORS.MAIN_GRAY, marginRight: 10 }}>Name:</CustomTypography>
              </td>
              <td>
                <CustomTypography>{indexZeroForNow?.talent_name}</CustomTypography>
              </td>
            </tr>
            <tr>
              <td>
                <CustomTypography style={{ color: COLORS.MAIN_GRAY, marginRight: 10 }}>Rep:</CustomTypography>
              </td>
              <td>
                <CustomTypography>{indexZeroForNow?.agency_name || 'Non-Represented'} </CustomTypography>
              </td>
            </tr>
            <tr>
              <td>
                <CustomTypography style={{ color: COLORS.MAIN_GRAY, marginRight: 10 }}>Role:</CustomTypography>
              </td>
              <td>
                <CustomTypography>{indexZeroForNow?.casting_role_name}</CustomTypography>
              </td>
            </tr>
            <tr>
              <td>
                <CustomTypography style={{ color: COLORS.MAIN_GRAY, marginRight: 10 }}>Time:</CustomTypography>
              </td>
              <td>
                <CustomTypography>{moment.utc(indexZeroForNow?.schedule_time_in).format('hh:mm A')}</CustomTypography>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <CustomTypography style={{ textAlign: 'center' }}>
        If this is you, please proceed to finish check-in, or cancel to go back
      </CustomTypography>
      <div
        style={{
          display: 'flex',
          gap: 20,
          width: '100%',
        }}
      >
        <Button
          fullWidth
          onClick={onCancel}
          style={{
            height: 50,
          }}
          variant="outlined"
          color="primary"
        >
          <CustomTypography fontSize={16} fontWeight={700} color="white">
            Cancel
          </CustomTypography>
        </Button>
        <Button
          disabled={isLoading}
          fullWidth
          onClick={proceed}
          style={{
            background: COLORS.PRIMARY,
            height: 50,
          }}
        >
          {isLoading ? (
            <CircularProgress style={{ color: 'white' }} size={25} />
          ) : (
            <CustomTypography fontSize={16} fontWeight={700} color="white">
              Proceed
            </CustomTypography>
          )}
        </Button>
      </div>
    </div>
  );
};

export default Result;
function dispatch(arg0: any) {
  throw new Error('Function not implemented.');
}
